import { firebaseAnalyticsAdapter } from '@/adapters/analytics';
import { createUserAwareAnalyticsAdapter } from '@/adapters/analytics/createUserAwareAnalyticsAdapter';
import { getCurrentAccountId } from '@/adapters/analytics/currentAccountId';
import { getCurrentUserId } from '@/adapters/analytics/currentUserId';
import {
  createScreenAnalyticsStore,
  type ScreenAnalyticsAdapters,
} from '@/stores/createScreenAnalyticsStore';

const productionAdapters: ScreenAnalyticsAdapters = {
  analytics: createUserAwareAnalyticsAdapter(
    firebaseAnalyticsAdapter,
    () => getCurrentUserId(),
    () => getCurrentAccountId(),
  ),
};

const useScreenAnalyticsStore = createScreenAnalyticsStore(productionAdapters);

export { useScreenAnalyticsStore };
